import { Components, Theme } from '@mui/material'

export const MuiTooltip: Components<Omit<Theme, 'components'>>['MuiTooltip'] = {
  defaultProps: {
    arrow: true,
  },
  styleOverrides: {
    tooltip: ({ theme }) => ({
      backgroundColor: theme.palette.bg.inverted,
      color: theme.palette.text.inverted,
      borderRadius: theme.shape['radius-xs'],
      padding: theme.spacing(0.5, 1.5),
      ...theme.typography['small-regular'],
    }),
    arrow: ({ theme }) => ({
      color: theme.palette.bg.inverted,
    }),
    popper: ({ theme }) => ({
      '&[data-popper-placement*="bottom"] .MuiTooltip-tooltip.MuiTooltip-tooltipPlacementBottom': {
        marginTop: theme.spacing(3),
      },
    }),
  },
}
